const cancelRequest = ({ctaHandler = null, id = 'cancelRequest'} = {}) => ({
    id,
    type: 'informative',
    options: {
        headerIconClass: 'odf-icon-loading',
        hasCloseIcon: false,
        contentType: 'status',
        hasCTA: !!ctaHandler,
    },
    ctaHandler,
});

module.exports = {
    cancelRequest,
};
